// src/seo/JsonLd.jsx
import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Dane strukturalne dla konkretnej podstrony.
 * Nie dubluje tagów meta - dokłada wyłącznie bloki JSON-LD.
 */
const JsonLd = ({ data }) => {
  const blocks = (Array.isArray(data) ? data : [data]).filter(Boolean);
  if (!blocks.length) return null;

  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default JsonLd;
